import { editInsuranceProviderIdentityOptions, getInsuranceProviderOptions, type InsuranceProviderViewModel } from '@generated';
import { Form } from '~/shared/forms/Form';
import { FooterButtonContainer } from '~/shared/forms/buttons/FooterButtonContainer';
import { FormSubmitButton } from '~/shared/forms/buttons/FormSubmitButton';
import { TextFormField } from '~/shared/forms/controls/fields/text-fields/TextFormField';
import { PhoneNumberFormField } from '~/shared/forms/controls/fields/text-fields/PhoneNumberFormField';
import Yup from '~/util/yup';

interface ContactsTabProps {
	provider: InsuranceProviderViewModel;
}

export function ContactsTab({ provider }: ContactsTabProps) {
	return (
		<div className="mt-6">
			<div className="rounded-xl border border-gray-200 bg-white p-6 shadow-sm">
				<h3 className="mb-4 text-lg font-semibold text-gray-900">Contact Information</h3>
				<Form
					initialValues={{
						insuranceProviderId: provider.id,
						payerIdentifier: provider.payerIdentifier ?? '',
						stateCode: provider.stateCode ?? '',
						claimsPhone: provider?.claimsPhone ?? '',
						claimsEmail: provider?.claimsEmail ?? '',
						authPhone: provider?.authPhone ?? '',
						authEmail: provider?.authEmail ?? '',
						defaultBillingModelId: provider.defaultBillingModelId ?? null,
						defaultClaimSubmissionModelId: provider.defaultClaimSubmissionModelId ?? null
					}}
					validationSchema={Yup.object().shape({
						payerIdentifier: Yup.string().label('Payer Identifier').nullable(),
						claimsPhone: Yup.string().label('Claims Phone').nullable(),
						claimsEmail: Yup.string().label('Claims Email').nullable().email(),
						authPhone: Yup.string().label('Auth Phone').nullable(),
						authEmail: Yup.string().label('Auth Email').nullable().email()
					})}
					saveMutation={{
						...editInsuranceProviderIdentityOptions,
						invalidateQueryKeys: [getInsuranceProviderOptions(provider.id).queryKey],
						onSuccessMessage: 'Contact information updated successfully'
					}}
				>
					{formHelpers => (
						<>
							{formHelpers.errorElement}
							<div className="space-y-6">
								<div className="grid grid-cols-2 gap-6">
									<TextFormField name="payerIdentifier" inputProps={{ placeholder: 'Enter Payer Identifier' }} />
									<TextFormField name="stateCode" inputProps={{ placeholder: 'Enter State Code' }} />
								</div>
								<h4 className="font-medium text-gray-700">Claims Contact</h4>
								<div className="grid grid-cols-2 gap-6">
									<PhoneNumberFormField name="contactInformation.claimsPhone" />
									<TextFormField name="contactInformation.claimsEmail" inputProps={{ placeholder: 'Claims Email' }} />
								</div>
								<h4 className="font-medium text-gray-700">Authorization Contact</h4>
								<div className="grid grid-cols-2 gap-6">
									<PhoneNumberFormField name="contactInformation.authPhone" />
									<TextFormField name="contactInformation.authEmail" inputProps={{ placeholder: 'Auth Email' }} />
								</div>
								<TextFormField name="contactInformation.notes" inputProps={{ placeholder: 'Additional notes...' }} />
								<FooterButtonContainer className="border-t border-gray-200 pt-4">
									<FormSubmitButton />
								</FooterButtonContainer>
							</div>
						</>
					)}
				</Form>
			</div>
		</div>
	);
}
